import $ from 'jquery'

/**
 * Send API requests to an address API for getting coordinates and other info.
 */
class AddressSearch {
  constructor() {
    this.source = 'https://nominatim.openstreetmap.org/search'
  }

  /**
   * Send a request to the API for information on an address.
   */
  async search(q, format = 'json') {
    let result = []
    if (q !== '') {
      try {
        console.log('AddressSearch', 'Querying source', q)
        result = await $.get(this.source, {q, format})
      }
      catch (e) {
        console.log('AddressSearch Error', e)
      }
    }

    return result
  }

  /**
   * Return coordinates and boundaries of an address or throw an AddressSearchError.
   */
  async locate(address) {
    const results = await this.search(address)
    let locationInfo = null
    if (results.length > 0) {
      const location = results[0]
      const coordinates = {
        lat: location.lat,
        lng: location.lon,
      }
      let bounds = null
      if (location.boundingbox) {
        bounds = [
          {lat: location.boundingbox[0], lon: location.boundingbox[2]},
          {lat: location.boundingbox[1], lon: location.boundingbox[3]},
        ]
      }
      locationInfo = {
        coordinates,
        bounds
      }
    }
    else {
      throw new AddressSearchError('No Results', 'Address not found.')
    }

    return locationInfo
  }
}

/**
 * A throwable error for errors that occur while searching for an address.
 */
class AddressSearchError extends Error { }

export { AddressSearch, AddressSearchError }
